import React from 'react'

const GameWrapper = ({icon, name, packageName}) => {
    return (
        <a
            className="game-wrapper"
            href={`https://play.google.com/store/apps/details?id=${packageName}`}
            rel="noopener noreferrer"
            target="_blank"
        >
            <span className="icon-name">
                <img src={`/images/${icon}`} alt={ `${name} game icon`} className="game-icon" />
                <h5 className="game-name">{name}</h5>
            </span>
        </a>
    )
}
export default GameWrapper;